﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import ForelopigUttalelseSkjemaSideDto from './Models/ForelopigUttalelseSkjemaSideDto';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import { ForelopigUttalelseSkjemaSideAppState } from './Store/index';
import Steg1ComponentVisning from './Components/Steg1';
import Steg2ComponentVisning from './Components/Steg2';
import Steg3ComponentVisning from './Components/Steg3';
import Steg4aComponentVisning from './Components/Steg4a';
import Steg4bComponentVisning from './Components/Steg4b';
import Steg5ComponentVisning from './Components/Steg5';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';

interface AppOwnProps {}
type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);
export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }
    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel } = this.props.epiContext;

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }
        if (epiModel != null) {
            return (
                <div className="c-veileder">
                    <Steg1ComponentVisning 
                        ledetekst = {contentResolver(epiContext, 'steg1Ledetekst')}
                        onChange = {(nyttValg: Valg<ValgTypes.BrukerInfo>): void => {
                                dispatchUpdateValg({ brukerInfo: nyttValg })
                            }
                        }
                        value = {valg.brukerInfo}
                        tittel = {contentResolver(epiContext, 'steg1Overskrift')}
                        forklaring = {contentResolver(epiContext, 'steg1Ingress')}
                        neverCollapse = {false}
                        sporsmalId = {"steg1"}
                    />
                
                    {resultat.visSteg2 && (
                        <Steg2ComponentVisning 
                            ledetekst = {contentResolver(epiContext, 'steg2Ledetekst')}
                            onChange = {(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ utdanning: nyttValg })
                                }
                            }
                            value = {valg.utdanning}
                            tittel = {contentResolver(epiContext, 'steg2Overskrift')}
                            forklaring = {contentResolver(epiContext, 'steg2Ingress')}
                            neverCollapse = {true}
                            sporsmalId = {"steg2"}
                        />
                    )}
                    {resultat.visSteg3 && (
                        <Steg3ComponentVisning 
                            ledetekst = {contentResolver(epiContext, 'steg3Ledetekst')}
                            onChange = {(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ land: nyttValg })
                                }
                            }
                            value = {valg.land}
                            tittel = {contentResolver(epiContext, 'steg3Overskrift')}
                            forklaring = {contentResolver(epiContext, 'steg3Ingress')}
                            neverCollapse = {false}
                            sporsmalId = {"steg3"}
                        />
                    )}
                    {resultat.visSteg4a && (
                        <Steg4aComponentVisning 
                            ledetekst = {contentResolver(epiContext, 'steg4LedetekstA')}
                            onChange = {(nyttValg: Valg<ValgTypes.Periode>): void => {
                                    dispatchUpdateValg({ periode: nyttValg })
                                }
                            }
                            value = {valg.periode}
                            tittel = {contentResolver(epiContext, 'steg4Overskrift')}
                            forklaring = {contentResolver(epiContext, 'steg4Ingress')}
                            neverCollapse = {false}
                            sporsmalId = {"steg4a"}
                        />
                    )}
                    {resultat.visSteg4b && (
                        <Steg4bComponentVisning 
                            ledetekst = {contentResolver(epiContext, 'steg4LedetekstB')}
                            onChange = {(nyttValg: Valg<ValgTypes.Periode>): void => {
                                    dispatchUpdateValg({ periode: nyttValg })
                                }
                            }
                            value = {valg.periode}
                            tittel = {contentResolver(epiContext, 'steg4Overskrift')}
                            forklaring = {contentResolver(epiContext, 'steg4Ingress')}
                            neverCollapse = {false}
                            sporsmalId = {"steg4b"}
                        />
                    )}
                    {resultat.visSteg5 && (
                        <Steg5ComponentVisning 
                            valg = {valg}
                            tittel = {contentResolver(epiContext, 'steg5Overskrift')}
                            forklaring = {contentResolver(epiContext, 'steg5Ingress')}
                            neverCollapse = {true}
                            sporsmalId = {"steg5"}
                        />
                    )}
                </div>
            )
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (nyttValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ForelopigUttalelseSkjemaSideAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: ForelopigUttalelseSkjemaSideAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
